@if (product()) {
  <div class="mt-d">
    <form nz-form [nzLayout]="'vertical'">
    <div nz-row [nzGutter]="16" nzAlign="top">
      <div nz-col [nzXs]="24" [nzSm]="isRangeProduct() ? 24 : 12">
        <nz-form-item>
          <nz-form-label>
            @if (isPeriodProduct() && periodOptions().length === 1) {
              {{ 'common.period' | actrans }}
            } @else {
              {{ 'app.cbapi5.common.selectDate' | actrans }}
            }
          </nz-form-label>
          <nz-form-control>
            @if (isPeriodProduct()) {
              @if (periodOptions().length > 1) {
                <nz-select
                  [ngModel]="selectedPeriod()"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="onPeriodChange($event)"
                  [nzAllowClear]="false">
                  @for (opt of periodOptions(); track opt.value) {
                    <nz-option [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
                  }
                </nz-select>
              } @else if (periodOptions().length === 1) {
                <div class="m-1 ml-d">{{ periodOptions()[0].label }}</div>
              } @else {
                <div class="m-1 ml-d">{{ period().from }} - {{ period().to }}</div>
              }
            } @else if (isRangeProduct()) {
              @if (!isStartBeforeEnd()) {
                <nz-input-group class="range-accommodation" nzPrefixIcon="calendar">
                  <div class="inline-flex">
                    <nz-date-picker
                      [ngModel]="startDate()"
                      [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="onStartDateChange($event)"
                      [nzDisabledDate]="disabledDate"
                      [nzAllowClear]="false"
                      [nzFormat]="'yyyy-MM-dd'"
                      style="width: auto; min-width: 120px;">
                    </nz-date-picker>
                  </div>
                  <div class="inline-flex mx-d">
                    <span nz-icon nzType="arrow-right" nzTheme="outline"></span>
                  </div>
                  <div class="inline-flex">
                    <nz-date-picker
                      [ngModel]="endDate()"
                      [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="onEndDateChange($event)"
                      [nzDisabledDate]="pickerDisabledDateRangeEnd"
                      [nzAllowClear]="false"
                      [nzFormat]="'yyyy-MM-dd'"
                      style="width: auto; min-width: 120px;">
                    </nz-date-picker>
                  </div>
                </nz-input-group>
              } @else {
                <nz-range-picker
                  [ngModel]="[period().from, period().to]"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="onDateRangeChange($event)"
                  [nzDisabledDate]="disabledDate"
                  [nzAllowClear]="false">
                </nz-range-picker>
              }
            } @else {
              <nz-date-picker
                [ngModel]="period().from"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onSingleDateChange($event)"
                [nzDisabledDate]="disabledDate"
                [nzAllowClear]="false">
              </nz-date-picker>
            }
          </nz-form-control>
        </nz-form-item>
      </div>

      @if (isTimeProduct()) {
        @if (product()?.useTimegrid) {
          <div nz-col [nzXs]="24" [nzSm]="12">
            <btlib-order-timegrid></btlib-order-timegrid>
          </div>
        } @else {
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label>{{ 'common.time' | actrans }}</nz-form-label>
              <nz-form-control>
                @if (timeOptions().length > 1) {
                  <nz-select [ngModel]="selectedTime()" [ngModelOptions]="{standalone: true}" (ngModelChange)="onTimeChange($event)">
                    @for (t of timeOptions(); track t.value) {
                      <nz-option [nzValue]="t.value" [nzLabel]="t.label"></nz-option>
                    }
                  </nz-select>
                } @else {
                  <div class="ci-time-display">{{ selectedTimeLabel() }}</div>
                }
              </nz-form-control>
            </nz-form-item>
          </div>
        }
      }

      @if (product()?.guestProduct !== false) {
        <div nz-col [nzXs]="24" [nzSm]="24">
          <nz-form-item>
            <nz-form-label>{{ guestsLabel() | actrans }}</nz-form-label>
            <nz-form-control>
              <div class="ci-guests">
                @for (cat of guestCategories(); track cat.idx) {
                  <div class="ci-guest-cat">
                    <button nz-button nzSize="small" nzType="default" type="button"
                            (click)="decrementGuest(cat.idx)" [disabled]="guests().counts[cat.idx] <= 0">
                      <i nz-icon nzType="minus"></i>
                    </button>
                    <input
                      nz-input
                      nzSize="small"
                      type="number"
                      class="ci-guest-input"
                      [ngModel]="guests().counts[cat.idx]"
                      [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="onGuestInput(cat.idx, $event)"
                      [min]="0"
                      [max]="cat.max" />
                    <button nz-button nzSize="small" nzType="default" type="button"
                            (click)="incrementGuest(cat.idx)" [disabled]="guests().counts[cat.idx] >= cat.max">
                      <i nz-icon nzType="plus"></i>
                    </button>
                    @if (guestCategories().length > 1) {
                      <span class="ci-guest-label">{{ cat.mk | actrans }}</span>
                    }
                  </div>
                }
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>
      }
    </div>
    </form>
  </div>
}
